/*
  Composant contenant l'injection des méthodes pour les composants
 */
import { isTheme } from '../Utils/isTheme'

export default {
  inject: [
    'Routes',
    'getJSON',
    'postJSON',
    'putJSON',
    'patchJSON',
    'deleteJSON',
    'getFile',
    'getParam',
    'addValue',
    'setValue',
    'escapeHtml',
    'getParamsValue',
    'getFieldLabel',
    'getBoolLabel',
    'getObjectValueByPropertyPath',
    'getRoundFloat',
  ],
  methods: {
    isTheme(...themes) {
      return isTheme(...themes)
    },
    toast(message) {
      this.$root.toasts.push(message) // FIXME: Should be refactored with a store
    },
    isWalletStatus(status) {
      return ['DELIVERED', 'COMPLETE', 'PAID', 'CANCELED', 'FINISH', 'PROLONGATION', 'CESSION', 'ENDED'].includes(
        status,
      )
    },
    async downloadFile(location, name, delegateErrorHandling = false) {
      try {
        const fileContent = await this.getFile(location)

        const dataUrl = window.URL.createObjectURL(fileContent)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = dataUrl

        a.download = name
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(dataUrl)
      } catch (error) {
        if (!delegateErrorHandling) {
          this.toast(this.$t('document.downloadError'))
        } else {
          throw error
        }
      }
    },
    hasRole(expectedRoles) {
      if (!Array.isArray(expectedRoles)) {
        expectedRoles = [expectedRoles]
      }
      return expectedRoles.some((role) => roles.includes(role))
    },
    parseIntParam(key) {
      const params = new URLSearchParams(window.location.search)
      const value = parseInt(params.get(key))
      return !value || isNaN(value) ? 0 : value
    },
  },
}
